const LOGO_SRC = {
  farbig: "/fundio-logo-light.png",
  weiss: "/fundio-logo-dark.png",
};

export function FundioLogo({ className = "", height = 30, variant = "farbig" }) {
  return (
    <img
      src={LOGO_SRC[variant]}
      alt="Fundio"
      style={{ height }}
      className={`w-auto object-contain ${className}`}
      draggable="false"
      data-testid="fundio-logo"
    />
  );
}
